import { debugFeature } from '~/params'
import '~/styles/global.css'

const features = ['trees', 'allowlist']

const now = Date.now()

let turn = {
  viewedAt: now,
  feature: 'trees',
}
const turnStr = localStorage.getItem('feature-turn')
if (turnStr) {
  try {
    turn = JSON.parse(turnStr) as typeof turn
  } catch (error) {
    console.error('Error parsing turn:', error)
  }
}

const shouldShowNextFeature =
  now > turn.viewedAt &&
  new Date(now).getDate() !== new Date(turn.viewedAt).getDate()

if (shouldShowNextFeature) {
  turn.viewedAt = now
  const lastViewedFeatureIndex = features.findIndex(
    (feat) => feat === turn.feature,
  )
  if (lastViewedFeatureIndex === features.length - 1) {
    turn.feature = features[0]
  } else {
    turn.feature = features[lastViewedFeatureIndex + 1]
  }
}

// Override with debug feature if provided via URL param
if (debugFeature && features.includes(debugFeature)) {
  turn.feature = debugFeature
}

export { turn }

export function saveTurn() {
  localStorage.setItem('feature-turn', JSON.stringify(turn))
}
